var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button-bar"},_vm._l((_vm.contentTabs),function(tab_e,tab_k){return _c('div',{key:tab_k,staticClass:"switch-button",class:{active:_vm.isActiviated(tab_e)},on:{"click":function($event){return _vm.contentTabOnclick(tab_e)}}},[_c('p',[_vm._v(_vm._s(_vm.$t(tab_e.textLabel)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }